import { api } from '@services/api';
import {
  GitBranchesResponseSchema,
  GitCredentialResponseSchema,
  GitCredentialsListSchema,
  GitProjectSchema,
  GitProjectsListSchema,
  GitServersResponseSchema,
  GitServerSchema,
} from '../schemas/git.schemas';
import type {
  GitCredentialUpsertRequest,
  GitServerCreateRequest,
  GitServerUpdateRequest,
} from '../types/git.types';

export const gitApi = {
  async listServers() {
    const res = await api.get('/git/servers');
    return GitServersResponseSchema.parse(res.data);
  },

  async createServer(body: GitServerCreateRequest) {
    const res = await api.post('/git/servers', body);
    return GitServerSchema.parse(res.data);
  },

  async updateServer(serverId: string, body: GitServerUpdateRequest) {
    const res = await api.patch(`/git/servers/${serverId}`, body);
    return GitServerSchema.parse(res.data);
  },

  async deleteServer(serverId: string) {
    await api.delete(`/git/servers/${serverId}`);
  },

  async listCredentials() {
    const res = await api.get('/git/credentials');
    return GitCredentialsListSchema.parse(res.data);
  },

  async setCredential(serverId: string, body: GitCredentialUpsertRequest) {
    const res = await api.put(`/git/credentials/${serverId}`, body);
    return GitCredentialResponseSchema.parse(res.data);
  },

  async deleteCredential(serverId: string) {
    await api.delete(`/git/credentials/${serverId}`);
  },

  async listProjects(
    serverId: string,
    search: string | null,
    page: number,
    perPage: number,
  ) {
    const params: Record<string, string | number> = { page, per_page: perPage };
    if (search) params.search = search;
    const res = await api.get(`/git/servers/${serverId}/projects`, { params });
    return GitProjectsListSchema.parse(res.data);
  },

  async getProject(serverId: string, externalRef: string) {
    const res = await api.get(
      `/git/servers/${serverId}/projects/${encodeURIComponent(externalRef)}`,
    );
    return GitProjectSchema.parse(res.data);
  },

  async listBranches(serverId: string, externalRef: string) {
    const res = await api.get(
      `/git/servers/${serverId}/projects/${encodeURIComponent(externalRef)}/branches`,
    );
    return GitBranchesResponseSchema.parse(res.data);
  },

  async lookupProject(serverId: string, externalRef: string) {
    const res = await api.post(
      `/git/servers/${serverId}/projects/lookup`,
      { external_ref: externalRef },
    );
    return GitProjectSchema.parse(res.data);
  },
};
